/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation RelaisSelfcareSimulationRecapMutation {
    relaisSelfcareSimulationRecap_M_simulation_recap {
      ok
      error
      
    }
  }
`;

export default mutation;
